import * as React from 'react'
import * as Router from 'react-router-dom'

export function LinkButton(props: Router.LinkProps & { disabled?: boolean }) {
  return (
    <Router.Link
      className={`inline-block transition shadow-md rounded-full
      px-4 py-2 text-white text-xl font-semibold bg-green-500 focus:outline-none 
      ${
        props.disabled
          ? 'opacity-50 ring-0'
          : 'hover:bg-green-600 focus:ring-4 focus:ring-green-500 focus:ring-opacity-50'
      }`}
      {...props}
    />
  )
}

export function Button(props: React.ButtonHTMLAttributes<HTMLButtonElement> & { disabled?: boolean }) {
  return (
    <button
      className={`inline-block transition shadow-md rounded-full
    px-4 py-2 text-white text-xl font-semibold bg-green-500 focus:outline-none 
      ${
        props.disabled
          ? 'opacity-50 ring-0'
          : 'hover:bg-green-600 focus:ring-4 focus:ring-green-500 focus:ring-opacity-50'
      }`}
      {...props}
    />
  )
}
